const DEFAULT_VALUES = {
  fineAmount: 0,
  licencePoints: 0,
  drivingBanPeriod: 0,
};

const calculate = (data) => {
  if (data.DURATION == null || data.DANGER == null) {
    return DEFAULT_VALUES;
  }

  if (data.DURATION === "LESS_THAN_1_SECOND") {
    if (data.DANGER === "YES") {
      return {
        fineAmount: 200,
        licencePoints: 2,
        drivingBanPeriod: 1,
      };
    }

    return {
      fineAmount: 90,
      licencePoints: 1,
    };
  }

  if (data.DANGER === "YES") {
    return {
      fineAmount: 320,
      licencePoints: 2,
      drivingBanPeriod: 1,
    };
  }

  return {
    fineAmount: 200,
    licencePoints: 2,
    drivingBanPeriod: 1,
  };
};

export default calculate;
